const p = {
  id: 1,
  title: "PARK DESIGN",
  subtitle: "FORMER AIRPORT",
  details: {
    type: "comeptition design",
    date: "08.2020",
    "co-authors": "Jolma Architects",
  },
  bigImgs: ["Rento/Main_2.jpg", "Rento/Main_3.jpg", "Rento/Main_4.jpg"],
  imgs: [],
  split: {
    img: "Rento/Main_1.jpg",
    desc: [
      "The Rento project, or Malmi Rentoasemapuisto, was made in cooperation with the Finnish studio Jolma Architects, where I completed my internship in 2020.",
      "The scope of the study was the area of the former Malmi airport in Helsinki, which the city designated for multi-family housing. The project focused on the development of an innovative park in the center of the estate.",
      "The park was a symbiotic synthesis of recreational, ecological and social functions.",
      "The activities were grouped along the main route, the axis of which was marked by the former airport runways. Historic infrastructure buildings were transformed into modern cultural centers.",
      "The green and blue network of the park consisted of the various biotopes characteristic of the wild nature of Finland. They fulfilled the functions of ecosystems, inter alia, by creating extensive retention basins.",
    ],
  },
};

export default p;
